const { Box, Chip } = require("@mui/material");

export const renderMultipler = (
  selectedIds,
  options,
  config = {
    idLabel: "name",
    idValue: "id",
    chip: false,
  },
) => {
  const { idLabel, idValue, chip } = config;
  const selectedItems = options?.filter((item) => selectedIds.includes(item[idValue])) || [];
  if (!chip) {
    return selectedItems.map((item) => item[idLabel]).join(", ");
  }
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
      {selectedItems.map((item) => (
        <Chip key={item[idValue]} size="small" label={item[idLabel]} />
      ))}
    </Box>
  );
};
